import About from "../features/about";

const AboutPage = () => {
  return (
    <div className="relative bg-white">
      <About />
    </div>
  );
};

export default AboutPage;
